import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, NavLink } from "react-router-dom";
import { put } from '../../utils/api';
import { Form, FormInput } from '../common/Form';

const ExhibitorEditLinks = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
    const exhibitor = useSelector(state => state.exhibitor);
    const [ youtube, setYoutube ] = useState('');
	const [ rutube, setRutube ] = useState('');
	const [ vk, setVk ] = useState('');
    const [ telegram, setTelegram ] = useState('');
    const [ yazen, setYazen ] = useState('');
    const [ success, setSuccess ] = useState('');
    const [ isSaving, setIsSaving ] = useState(false);
    const [ saveError, setSaveError ] = useState('');

    // Установка начальных значений
    useEffect(() => {
        if(!exhibitor || !exhibitor.links) return;
        setYoutube(exhibitor.links.youtube);
        setRutube(exhibitor.links.rutube);
        setVk(exhibitor.links.vk);
        setTelegram(exhibitor.links.telegram);
        setYazen(exhibitor.links.yazen);
    }, [exhibitor]);

    // Проверка введенных URL
    const checkURL = (url) => {
        if(!url) return ' '; // Пустой УРЛ значит что мы хотим его удалить. Для этого серверу шлем пробел.
        if(url.match(/^https?:\/\//i)) {
            return url;
        } else {
            return 'https://' + url;
        }
    };

    // Отправка данных
	const onSubmit = async () => {
        setIsSaving(true);
        setSaveError('');
        setSuccess('');
        const links = {
            youtube: checkURL(youtube),
            rutube: checkURL(rutube),
            vk: checkURL(vk),
            telegram: checkURL(telegram),
            yazen: checkURL(yazen),
        };
        const result = await put('/exhibitors/' + exhibitor._id, { links });
        if(result.error) {
            setSaveError(result.error);
        } else {
            setSuccess('exhibitoredit.success');
			navigate('/cabinet/exhibitorview/' + exhibitor._id + '/action/updated');
        }
        setIsSaving(false);
	};

    return (
		<div>
	    	<h1>{t('exhibitoredit.title_links')}</h1>
			{isSaving ? <span>{t('common.loading')}</span> :
			<Form
                success={success}
                error={saveError}
                info='exhibitoredit.subtitle'
                submit={t('common.save_changes')}
				onSubmit={onSubmit}
            >
				
				<FormInput
					id='youtube'
                    type='text'
					value={youtube}
					onChange={setYoutube}
                    placeholder={t('exhibitoredit.youtube_tpl')}
                    label={t('exhibitoredit.youtube')}
				/>

				<FormInput
					id='rutube'
                    type='text'
					value={rutube}
					onChange={setRutube}
                    placeholder={t('exhibitoredit.rutube_tpl')}
                    label={t('exhibitoredit.rutube')}
				/>

				<FormInput
					id='vk'
                    type='text'
					value={vk}
					onChange={setVk}
                    placeholder={t('exhibitoredit.vk_tpl')}
                    label={t('exhibitoredit.vk')}
				/>

				<FormInput
					id='telegram'
                    type='text'
					value={telegram}
					onChange={setTelegram}
                    placeholder={t('exhibitoredit.telegram_tpl')}
                    label={t('exhibitoredit.telegram')}
				/>

				<FormInput
					id='yazen'
                    type='text'
					value={yazen}
					onChange={setYazen}
                    placeholder={t('exhibitoredit.yazen_tpl')}
                    label={t('exhibitoredit.yazen')}
				/>
			</Form>}

            <NavLink to={'/cabinet/exhibitorview/' + exhibitor._id}>
                {t('exhibitoredit.back')}
            </NavLink>
		</div>
	);
};

export default ExhibitorEditLinks;
